import { type ReactNode, useEffect } from "react";

import { setAuthHandlers, setTokenGetter } from "@/lib/api/client";

import { AuthContext, LOCAL_AUTH } from "./context";

/** Auth off: the stub user, `getToken() → null`, and nothing to do on a 401 or 403. */
export function LocalAuthProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    setTokenGetter(null);
    setAuthHandlers(null);
  }, []);
  return <AuthContext.Provider value={LOCAL_AUTH}>{children}</AuthContext.Provider>;
}
